import React, { Component } from 'react'

class Thank extends Component {
    render () {
        return (
            <div style={{textAlign: "center"}}>
                <h1>Thank you.</h1>
            </div>
        )
    }
}

export default Thank


// WEBPACK FOOTER //
// ./src/Page/Component/Thank.js